import { render } from "./Battles.vue?vue&type=template&id=1f47f4c6&scoped=true"
import script from "./Battles.vue?vue&type=script&lang=js"
export * from "./Battles.vue?vue&type=script&lang=js"

import "./Battles.vue?vue&type=style&index=0&id=1f47f4c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f47f4c6"]])

export default __exports__